import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const getSkillAgentSearchesMeta = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-searches/meta`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentBrandCollections = async (
  brandId,
  tipologia = "",
) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-searches/meta/brands/${brandId}/collections`,
    {
      headers: authHeaders(),
      params: tipologia ? { tipologia } : {},
    },
  );
  return response.data;
};

/** Comprueba si una web propia es scrapeable / necesita adaptador. */
export const probeSkillAgentSourceUrl = async (url, tipologia = "") => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches/meta/probe-url`,
    { url, tipologia },
    { headers: authHeaders() },
  );
  return response.data;
};

/** Saldo / bloqueo ScrapingBee (webs muradas del SEARCH). */
export const getSkillAgentScrapingBeeCredits = async () => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-searches/meta/scrapingbee-credits`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const clearSkillAgentScrapingBeeCreditsBlock = async () => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches/meta/scrapingbee-credits/clear`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const listSkillAgentSearches = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-searches`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentSearchById = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-searches/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const createSkillAgentSearch = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSkillAgentSearch = async (id, payload) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-searches/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const runSkillAgentSearch = async (id, body = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches/${id}/run`,
    body,
    { headers: authHeaders() },
  );
  return response.data;
};

export const cancelSkillAgentSearch = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches/${id}/cancel`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillAgentSearch = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-searches/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const clearSkillAgentSearchPhotos = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches/${id}/clear-photos`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillAgentSearchItems = async (id, itemIds = []) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches/${id}/delete-items`,
    { itemIds },
    { headers: authHeaders() },
  );
  return response.data;
};

export const listSkillAgentSearchItems = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-searches/${id}/items`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const listSkillAgentSearchRuns = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-searches/${id}/runs`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const rerunSkillAgentSearchRun = async (searchId, runId, body = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-searches/${searchId}/runs/${runId}/rerun`,
    body,
    { headers: authHeaders() },
  );
  return response.data;
};

/** Fetch search image with auth and return a blob: URL (revoke when done). */
export const fetchSkillAgentSearchItemBlobUrl = async (itemId) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-searches/items/${itemId}/file`,
    { headers: authHeaders(), responseType: "blob" },
  );
  return URL.createObjectURL(response.data);
};
